const _url="https://api-univ.sitare.org/"

export function callGetApis(url, body, method) {
    return fetch(_url + url, {
        method: method,
        headers: {
            'Accept': 'application/json, text/plain, */*',
            'Cache-Control': 'no-cache, no-store, must-revalidate',
            'Pragma': 'no-cache',
            'Content-Type': 'application/json'
        },
        // body:JSON.stringify(body)
    }).then(res => res.json())
        .then(res => {
            return res
        });
}
export function callApis(url, body, method) {
    return fetch(_url + url, {
        method: method,
        headers: {
            'Accept': 'application/json, text/plain, */*',
            'Cache-Control': 'no-cache, no-store, must-revalidate',
            'Pragma': 'no-cache',
            'Content-Type': 'application/json'
        },
        body:JSON.stringify(body)
    }).then(res => res.json())
        .then(res => {
            return res
        });
}
export function callFetchApis(url, body, method) {
    return fetch(_url + url, {
        method: method,
        headers: {
            'Accept': 'application/json, text/plain, */*',
            'Cache-Control': 'no-cache, no-store, must-revalidate',
            'Pragma': 'no-cache',
            'Content-Type': 'application/json'
        },
        body:JSON.stringify(body)
    }).then(res => res.json())
        .then(res => {
            return res
        });
}